export const PF_EVENTS = {
  FIRST_EVENT_CREATED: "first_event_created",
  FIRST_PLAY_CREATED: "first_play_created",
  FIRST_EVALUATION_SUBMITTED: "first_evaluation_submitted",
  FIRST_PLAYER_INVITED: "first_player_invited",
  FIRST_COACH_INVITED: "first_coach_invited",
  FIRST_DEPTH_CHART_SAVED: "first_depth_chart_saved",
  FIRST_ANALYTICS_VIEWED: "first_analytics_viewed",
  FIRST_SEASON_CREATED: "first_season_created",
  SUBSCRIPTION_STARTED: "subscription_started",
  AI_COACH_FIRST_USED: "ai_coach_first_used",
  FIRST_STATS_RECORDED: "first_stats_recorded",
};

const KNOWN_EVENTS = new Set(Object.values(PF_EVENTS));

const withProductFruits = (fn) => {
  if (typeof window === "undefined") return;
  const run = () => {
    try {
      fn(window.productFruits);
    } catch {}
  };
  if (window.productFruitsIsReady) {
    run();
    return;
  }
  window.addEventListener("productfruits_ready", run, { once: true });
};

export const trackEvent = (event) => {
  if (!KNOWN_EVENTS.has(event)) return;
  withProductFruits((pf) => pf?.api?.events?.track?.(event));
};
